import React from 'react'
import './boot/networkBootstrap'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { HelmetProvider } from 'react-helmet-async'
import { ErrorBoundary } from 'react-error-boundary'

// Cache Management
import cacheManager from './utils/cacheManager'

// Contexts
import { NotificationProvider } from './contexts/notification/NotificationContext'
import { AuthProvider } from './contexts/AuthContext'
import { NetworkGuard } from './contexts/network/NetworkGuard'

// Components
import App from './App'
import ErrorFallback from './components/error/ErrorFallback'
import NetworkHealthPrompt from './components/common/NetworkHealthPrompt'

// Styles
import './styles/index.css'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 1,
      retryDelay: 1000,
    },
  },
})

// Initialize cache management
cacheManager.init();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <NotificationProvider>
                  <NetworkGuard>
                    <App />
                    <NetworkHealthPrompt />
                  </NetworkGuard>
                </NotificationProvider>
            </AuthProvider>
          </BrowserRouter>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)